module.exports = __webpack_public_path__ + "img/solution-software-system-pic-6.637ac5fa.png";